import { IndexByString } from "../redux/modules/insights/utils";

/**
 * Get site object by siteId from redux store
 */
export function getSiteById(id: string) {
  const store: any = require("../client").store;
  const sites: IndexByString<Insite.Site> = store.getState().userSites.sites;

  return sites[id];
}
